import { SearchInput } from './components/SearchInput';
import { SearchFilter } from '../SearchFilter';
import { FILTERS } from '../SearchFilter/constants';
import { Collapse } from '@mui/material';
import PropTypes from 'prop-types';

export function SearchBar({ displaySearch }) {
  return (
    <>
      <Collapse in={displaySearch}>
        <SearchInput />
      </Collapse>
      <SearchFilter customFilters={FILTERS} isOpen={true} />
    </>
  );
}

SearchBar.propTypes = {
  displaySearch: PropTypes.bool
};
